class ReadMore {
    constructor(DOMelement) {
        try {
            this.el = DOMelement;
            this.existingButton = this.el.lastElementChild;
            this.readMoreButton = null;
            this.opened = false;

            this.openedLimit = 300;
            this.closedLimit = 250;

            if (this.el.parentNode.classList.contains("global__hero-content-details")) {
                this.closedLimit = 500;
                this.openedLimit = 600;
            }

            this.contentContainers = Array.from(this.el.querySelectorAll("p"));
            this.originalContent = this.contentContainers.map((p) => p.innerText);

            // Calculate total content length
            this.totalContent = this.originalContent.join(" ");
            this.totalLength = this.totalContent.length;

            if (this.totalLength > this.openedLimit) {
                this.addReadMoreButton();
                this.setComponent();
                this.readMoreButton.addEventListener("click", this.toggle);
            }
        } catch (error) {
            console.error(error);
        }
    }

    addReadMoreButton = () => {
        const readMoreButton = document.createElement("button");
        readMoreButton.classList.add("sd-read-more__button", "sd-label");

        if (this.existingButton.innerText === "Read less") {
            this.existingButton.parentNode.removeChild(this.existingButton);
        }

        this.el.insertAdjacentElement("beforeend", readMoreButton);
        this.readMoreButton = this.el.lastElementChild;
    };

    setComponent = () => {
        let contentLength = 0;

        this.contentContainers.forEach((p, index) => {
            if (this.opened) {
                // Restore original content when expanded
                p.innerText = this.originalContent[index];
            } else {
                // Truncate content for closed state
                if (contentLength + this.originalContent[index].length > this.closedLimit) {
                    const remainingLength = this.closedLimit - contentLength;
                    p.innerText = `${this.originalContent[index].slice(0, remainingLength)}...`;
                } else {
                    p.innerText = this.originalContent[index];
                }
            }

            contentLength += this.originalContent[index].length;
            if (contentLength >= this.closedLimit && !this.opened) {
                return; // Stop processing further paragraphs in closed state
            }
        });

        this.readMoreButton.innerText = this.opened ? "Show Less" : "Show More";

        if (
            this.el.parentNode.classList.contains("sd-room-card__content") ||
            this.el.parentNode.classList.contains("truncable-content")
        ) {
            this.openedLimit = 2500;
            this.el.parentNode.classList.toggle("show-less");
            this.readMoreButton.innerText = this.opened ? "Read less" : "Read more";
        }
    };

    toggle = () => {
        this.opened = !this.opened;
        this.setComponent();
    };
}

export default ReadMore;
